/**
 * The focus view's context: above each card, the scenario (on a portfolio map,
 * the town) it belongs to. A cross-link between two towns reads as nothing
 * without it. The card's position is its top-left corner.
 */
export default function FocusTownCaptions({ nodes = [], positions = {}, scenarios = [] }) {
  const titleOf = new Map(scenarios.map((s) => [s.id, s.title]));
  return (
    <g className="focus-town-captions" pointerEvents="none">
      {nodes.map((n) => {
        const pos = positions[n.id];
        const title = titleOf.get(n.scenarioId || n.scenario_id);
        if (!pos || !title) return null;
        return (
          <text key={n.id} x={pos.x + 2} y={pos.y - 16} fontSize={22} fontWeight={600}
            letterSpacing="0.04em" fill="var(--text-muted-on-dark, #B8B8B8)">
            {title.toUpperCase()}
          </text>
        );
      })}
    </g>
  );
}
